import React, {memo} from 'react';
import {styles} from "./index";
import Space, {spaceSizes} from "@/app/components/Space";
import classNames from "classnames";

interface AuthTitleProps {
  title: string;
  subtitle?: string;
  className?: string;
}

const AuthTitle: React.FC<AuthTitleProps> = ({title, subtitle, className}) => {
  return (<div className={classNames(styles.title, className)}>
    <h1>{title}</h1>
    <Space h={spaceSizes.s6}/>
    <h2>{subtitle}</h2>
  </div>);
}

export default memo(AuthTitle);